import { classifyPageTypeFromPathname } from '@teo/widget-shared';
import type { EvidenceContext, PageEvidence } from '../evidence.js';

/** URL pathname heuristics (`/product/`, `/collections/`, …). */
export function collectUrlEvidence(context: EvidenceContext): PageEvidence[] {
  return [{ evidenceId: 'url:path', source: 'url-heuristics', kind: 'page-hint', scope: 'page', epoch: context.epoch, active: true,
    pageHint: classifyPageTypeFromPathname(context.pathname) }];
}
